import React, { useState } from 'react';
import Header from './header';
import Content from './content';
import Empty from './empty';

const Main = ({sID, data, setOption}) => {
  const [tab, setTab] = useState(0);

  const handleClick = (n) => {
    setTab(n);
    setOption({
      id: sID,
      tab: n,
    });
  };
  return (
    <>
      <Header sID={sID} />
      <section className="content__box">
        <div className="content__tab">
          <div className={!tab ? 'activate' : ''} onClick={() => handleClick(0)}>新车探馆</div>
          <div className={tab ? 'activate' : ''} onClick={() => handleClick(1)}>车展体验</div>
        </div>
        {
          data && data[tab] && data[tab].list && data[tab].list.length > 0 ?
          <Content data={data[tab]} />
          : 
          <Empty card={true} />
        }
      </section>
    </>
  )
}

export default Main;